/* eslint-disable quote-props */
export default {
  'forgot-password': 'Forgot your password',
  'or': 'or',
  'no-account': 'not registered yet',
  'password': 'Password',
  'login': 'Login',
};



// WEBPACK FOOTER //
// ./src/lang/en.js